<template>
    <div class="my-5">
        <dashboard-section-title>{{ title }}</dashboard-section-title>
        <template v-if="participantActivities && participantActivities.length > 0">
            <v-card rounded flat outlined>
                <template v-for="(participantActivity, index) of participantActivities">
                    <participant-activity-card
                        :key="participantActivity.id"
                        :participant-activity="participantActivity"
                    />
                    <v-divider
                        v-if="index + 1 < participantActivities.length"
                        :key="`divider-${participantActivity.id}`"
                    />
                </template>
            </v-card>
        </template>
        <v-card rounded flat outlined v-else>
            <v-skeleton-loader tile type="list-item-two-line" />
        </v-card>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { ParticipantActivityModel } from '../models';
import ParticipantActivityCard from './ParticipantActivityCard';

export default {
    components: {
        ParticipantActivityCard,
    },
    props: {
        participantActivities: Array,
    },
    computed: {
        ...mapState('organization', ['selectedOrganizationId']),
        title() {
            const message = this.$t('You have %value% new volunteers');
            return message.replace('%value%', this.participantActivities ? this.participantActivities.length : 0);
        },
    },
    methods: {
        markAsVieved() {
            const data = [];
            for (const participantActivity of this.participantActivities) {
                data.push({
                    id: participantActivity.id,
                    viewDate: new Date(),
                });
            }
            if (data.length > 0) {
                ParticipantActivityModel.patchList({
                    params: {
                        organization: this.selectedOrganizationId,
                        'response-group': 'org_backend_dashboard',
                    },
                    body: data,
                });
            }
        },
    },
    watch: {
        participantActivities() {
            this.markAsVieved();
        },
    },
};
</script>
